import { render, staticRenderFns } from "./DirectInterview.vue?vue&type=template&id=0b52caec&scoped=true&"
import script from "./DirectInterview.vue?vue&type=script&lang=js&"
export * from "./DirectInterview.vue?vue&type=script&lang=js&"
import style0 from "./DirectInterview.vue?vue&type=style&index=0&id=0b52caec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52caec",
  null
  
)

export default component.exports